import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import { checkInOutColumn } from "../../helpers/tableProps";
import TableComponent from "../TableComponent";

const InProgressPage = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const pageInfo = useSelector(JobSelectors.getTodayActivePaginationData)
  const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'active', part: "data" }))
  const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'active', part: "filter" }))
  const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'active', part: "sort" }))
  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    dispatch(JobActions.setTodayActivePageSize(pageSize));
    dispatch(JobActions.setTodayActiveFilter(filters));
    dispatch(JobActions.setTodayActiveSort(sortBy));
    dispatch(JobActions.fetchTodayActiveJobs(pageIndex));
  }, []);

  return (
    <TableComponent
      pageInfo={pageInfo}
      jobListData={jobListData}
      pageFilter={pageFilter}
      pageSort={pageSort}
      fetchData={fetchData}
      history={props.history}
      extraColumn={[
        checkInOutColumn(t),
        // createActionColumn(),
      ]}
    />
  )
}

export default InProgressPage